module.exports = __webpack_public_path__ + "img/ai_txt2img.1db66a2.png";